import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FieldLabel, TextField } from 't3-widgets'

import dakImage from '../../../../../../../data/img/dak.png'
import { VALIDATORS_CONFIG } from '../../../../../../common/constants'
import { validationChecker, getValidator, getTooltip } from '../../../common/operations'

import styles from '../pages.module.css'

const DakField = ({ dak, dakCorrectness, intl, onDakChange, serverVerified }) => {
    const [dakError, setDakError] = useState(false)

    const checker = validationChecker(dakCorrectness)
    const conf = VALIDATORS_CONFIG.step2

    const setError = () => {
        const errorDakFormat = new Error(intl.translate('ap_error_dak'))
        setDakError(dakCorrectness ? false : errorDakFormat)
    }

    if (serverVerified) {
        return (
            <div className={styles['input-field']}>
                <FieldLabel
                    id="dak-label"
                    label={intl.translate('ap_step2_dak')}
                    tooltip={getTooltip(intl.translate('ap_step2_dak'), intl.translate('ap_step2_dak_hint'), dakImage)}
                >
                    <div className={styles['validated-input-container']}>
                        <div className={styles['validated-input-field']}>
                            <TextField
                                id="dak-text-field"
                                value={dak}
                                onBlur={() => getValidator(conf.serialNo.enabled.equality, setError(), null)}
                                onChange={onDakChange}
                                onFocus={() => setDakError(false)}
                                error={dakError}
                                placeholder={intl.translate('wf_reporting_required')}
                            />
                        </div>
                        {checker}
                    </div>
                </FieldLabel>
            </div>
        )
    }

    return <div />
}

DakField.propTypes = {
    dak: PropTypes.string,
    dakCorrectness: PropTypes.boolean,
    intl: PropTypes.objectOf(PropTypes.func),
    onDakChange: PropTypes.func,
    serverVerified: PropTypes.boolean
}

export { DakField }
